import React from 'react';
import { Flex, Skeleton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router';
import { useSupportCenterAccess } from '../hooks/useSupportCenterAccess';

interface SupportCenterGateProps {
  children: React.ReactNode;
}

const SupportCenterGate = ({ children }: SupportCenterGateProps): React.ReactElement => {
  const { t } = useTranslation('common');
  const decision = useSupportCenterAccess();

  if (decision === 'deny') return <Navigate to='/' replace />;

  if (decision === 'loading') {
    return (
      <Flex direction='column' gap={4} px={8} py={4} role='status' aria-label={t('loading')}>
        <Skeleton height='88px' borderRadius='md' />
        <Skeleton height='320px' borderRadius='md' />
      </Flex>
    );
  }

  return <>{children}</>;
};

export default SupportCenterGate;
